'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isDirty = require('./selectors/isDirty');

var _isDirty2 = _interopRequireDefault(_isDirty);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _isDirty2.default)(_plain2.default);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/isDirty.js
// module id = 1330
// module chunks = 0